module.exports = "    .sticky-top{\n        top:80px;\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/products/product-filter/product-filter.component.css
// module id = ./src/app/products/product-filter/product-filter.component.css
// module chunks = main